<template>
  <div class="text-center ma-2">
    <v-snackbar
      v-model="snackbar"
      class=""
      :timeout="1500"
    >
      <v-progress-circular indeterminate />
      <span class="pl-2"> {{$t('downloadSnackbar')}} </span>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  data(){
    return{
      
    }
  },
  mounted(){
    //this.startDownloads()
    this.singleDownload()
  },
  computed: {
    snackbar: {
      get(){
        
        return this.$store.getters.getSnackDownload
      },
      set(value){
        this.$store.commit('setSnackDownload', value)
      }
    },
    text: {
      get(){
        return this.$store.getters.getSnackText
      }
    },
    project: {
      get(){
        return this.$store.getters.getProjectDownload
      }
    },
    selected: {
      get(){
        return this.$store.getters.getSelected
      }
    },
    downloadInProgress: {
      get(){
        return this.$store.getters.getDownloadInProgress
      },
      set(){
        return this.$store.dispatch('downloadsSetupFinished')
      }
    }
  },
  methods: {
    startDownloads(){
      let filesToDownload = 0
      this.selected.forEach(camera=>{
        camera.extractions.forEach(extraction=>{
          extraction.files.forEach(file=> {
            this.$extractions.downloadFile(this.project.id,file.id).then((response)=>{
              /*const fileStream = fs.createWriteStream(extraction.cameraName +'_' + extraction.downloadTimeRange +'_'+file.id + '.' + file.type);
              response.data.pipe(fileStream);/**/
              
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', extraction.cameraName +'_' + extraction.downloadTimeRange +'_'+file.id + '.' + file.type );
              document.body.appendChild(link);
              link.click();
              window.URL.revokeObjectURL(url);
              if(--filesToDownload == 0) {
                this.downloadInProgress = false
                this.$store.dispatch('snackAlert', true)
              }
            }).catch((e)=>{
              console.log('Error:',e)
              this.$store.dispatch('snackAlert', false)
              if(--filesToDownload == 0) {
                this.downloadInProgress = false
              }
            })
            /**/
          })
          this.downloadInProgress = false
          this.$store.dispatch('snackAlert', true)
        })
      })
    },
    singleDownload(){
      let extraction = this.project.extractions.findIndex(extr=> extr.files.findIndex(file=> file.id==this.selected[0].id)!==-1)
      if(extraction === -1){
        return null
      }
      this.selected.forEach(async file=>{
        
        const user = await this.$store.dispatch('getUser');
        let authToken = ''
        if (user) {
          authToken = user.access_token;
          this.$store.commit('userAuthenticated', user)
        }
        const url = config.VUE_APP_EXTRACTION + '/api/v1/projects/'+ this.project.id +'/files/'+ file.id+'/singledownload?authToken='+authToken;
        const link = document.createElement('a');
        link.href =  url
        link.setAttribute('download','');
        link.download=  extraction.cameraName +'_' + extraction.downloadTimeRange +'_'+file.id + '.' + file.type 
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link)
      })
    }
  }
}
</script>